import React, { useState , useEffect} from 'react';

/*
The current implementation of the session is not clear. In fact, the backend should be separated in two. One managing the AI / mindmap functions
suh as qa and assistant, while the second would manage the chat system proper. For the tim being, a common mongo db is used to store users, states,
and AI / mapmind aspects. The session persistence is not ensured yet and this forces the user to logout correctly for retrieving the stored state
at when reconnecting.
*/

const Login = ({socket, server_host,  login, roomId, onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [userExists, setUserExists] = useState(false);
  const [pre_filled, setPrefilled] = useState(false)
  const [pre_filled_value, setPrefilledValue] = useState('')

  const handleVerifyUser = () => {
    if (username) {
      try {
  // Émettre l'événement
         socket.emit('verifyUser', { username }, (error) => {
            if (error) {
                console.error('Erreur lors de l\'émission de l\'événement :', error);
            } else {
                console.log('Événement émis avec succès');
            }
        });
      } catch (error) {
          console.error('Erreur globale lors de l\'émission de l\'événement :', error);
      }
    }
  };
 
  const handleLogin = () => {
  if (username && password) {
      socket.emit('login', { username, password, roomId});
    }
  };

  useEffect(() => {

  if ((login != null) &&(login !== '')) {
    setUsername(login)
  }

  const pre_f = login !== ''
  setPrefilled(pre_f)
  const pre_f_value = pre_filled ? login : 'votre identifiant ?'
  setPrefilledValue(pre_f_value)
  if (pre_f) {
    handleVerifyUser()
  }


  const handleUserExists = () => {
    setUserExists(true);
  };

  const handleUserNotFound = () => {
    alert("Utilisateur non trouvé. Si vous n'êtes pas encore inscrits, contact@altai-ego.com");
    setUserExists(false);
  };

  const handleRetry = () => {
    alert("Suite à une erreur technique, Veuillez vous relogguer s'il vous plait.");
    socket.disconnect()
    setUserExists(false);
  };

  const handleUserLogedIn = () => {
    // alert('Vous êtes déjà en connection dans une autre session. Attendez la fin de cette session si vous ne pouvez la rejoindre.');
    setUserExists(false);
  };

  const handleLoginSuccess = ([uid, pseudo]) => {
    if (uid){
      console.log('logged in: ' + pseudo)
      onLogin(uid, pseudo, roomId);
    }
  };

  const handleLoginFailure = () => {
    // alert('Échec de la connexion, veuillez vérifier votre mot de passe, ou que vous n\'êtes pas déjà connecté.e sur un autre appareil.');
  };

  const handleLoginRoomFailure = () => {
    alert('Échec de la connexion, cette url est invalide, la salle est fermée.');
  };

    // Définir les écouteurs d'événements de Socket.io
    socket.on('userExists', handleUserExists);
    socket.on('userNotFound', handleUserNotFound);
    socket.on('bdNotFound', handleRetry);
    socket.on('userLogedIn', handleUserLogedIn);
    socket.on('loginSuccess', handleLoginSuccess);
    socket.on('loginFailure', handleLoginFailure);

    // Nettoyage des écouteurs lors du démontage du composant
    return () => {
      socket.off('userExists', handleUserExists);
      socket.off('userNotFound', handleUserNotFound);
      socket.off('userLogedIn', handleUserLogedIn);
      socket.off('loginSuccess', handleLoginSuccess);
      socket.off('loginFailure', handleLoginFailure);
    };
  }, [socket, login, username]);
  


    let protocol = process.env.REACT_APP_PROTOCOL
    if (protocol === undefined){
      protocol = "http"
    }
    console.log('app call protocol = ' + protocol)

  return (
    <div className='bienvenue'>
      <h1>Le premier des réseaux coachIAux</h1>
      <h2>Bienvenue sur la plateforme conversationnelle d'AltAI ego !</h2>
      <img width='15%' src={`${protocol}://${server_host}:3050/images/logo.png`} alt='Powered by Altai ego'/>
      <input
        type="email"
        readOnly={pre_filled}
        value={username !== undefined ? username : ''}
        onChange={(e) => setUsername(e.target.value.trim())}
        placeholder={pre_filled_value}
      />
      {userExists ? (
        <>
          <input
            type="password"
            value={password}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                // console.log('login then')
                handleLogin()
              }
            }}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Mot de passe ?"
          />
          <button onClick={handleLogin}>hop</button>
        </>
      ) : (
        <button onClick={handleVerifyUser}>hop</button>
      )}
      {userExists ? 
          (<input type="hidden" name="room_id" value={roomId}/>) : (<input type="hidden" name="room_id" value=''/>)}
    </div>
  );
};

export default Login;